export const environment = {
    production: false,
    client_demo: false,
    api_url: 'https://acengage-stag-be.devtomaster.com',
    socket_url:'wss://acengage-stag-be.devtomaster.com',
};